var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16089 12.5C5.78418 12.5 5.40353 12.3597 5.11558 12.0773L0.433407 7.51805C-0.144469 6.95511 -0.144469 6.04441 0.433407 5.48147C1.01128 4.91852 1.94614 4.91852 2.52402 5.48147L6.16089 9.02051L14.476 0.922207C15.0539 0.359264 15.9887 0.359264 16.5666 0.922207C17.1445 1.48515 17.1445 2.39585 16.5666 2.95879L7.20619 12.0773C6.91824 12.3597 6.53956 12.5 6.16089 12.5Z",
    fill: "#ffbe00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkYellow);
export default __webpack_public_path__ + "static/media/checkmark--yellow.5b1bd2241a33d381ab41d69fea4b1d0a.svg";
export { ForwardRef as ReactComponent };